export default [{
        path: '/',
        name: 'ARI_Home',
        component: require('./views/Home.vue'),

    },

    {
        path: '/*',
        name: 'Redirect',
        redirect: '/'
    },

];



// WEBPACK FOOTER //
// ./src/routes.js